import React from "react";
import { useInterviewContext } from "../../InterviewContext";
import "../../../styles/forms.scss";
import { useTranslation } from "react-i18next";
import DisabledTextArea from "../../../../components/DisabledTextArea";

const MotivationsPreview = ({ interview }) => {
  const { t } = useTranslation();

  return (
    <form className="salary-condition">
      <h1>{t("Motivations")}</h1>
      <div className="form-group">
        <label htmlFor="exitReason">{t("Exit Reason")}</label>
        <DisabledTextArea
          id="exitReason"
          name="exitReason"
          value={interview.availabilityAndConditions.exitReason}
        />
        <label htmlFor="otherProposals">{t("Other Proposals")}</label>
        <DisabledTextArea
          id="otherProposals"
          name="otherProposals"
          value={interview.availabilityAndConditions.otherProposals}
        />
      </div>
    </form>
  );
};

export default MotivationsPreview;
